import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApParagraphSkeletonComponent } from '@ap/skeleton';

import { SkeletonComponent } from './skeleton.component';

/**
 * @name SkeletonModule
 * @ngdoc module
 */
@NgModule({
    declarations: [SkeletonComponent],
    imports: [ApParagraphSkeletonComponent, CommonModule],
    exports: [SkeletonComponent]
})
export class SkeletonModule {}
